import React from 'react';
import styled, { css, keyframes } from 'styled-components';

interface SkeletonLoadingProps {
  width: number;
  height: number;
  circle?: boolean;
  color?: string;
}

const LoadingAnimation = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  `;

export const Loading = css`
  background: var(--decorative-subdued);
  background-clip: content-box; // Don't skeleton load the padding
  animation: ${LoadingAnimation} 1.5s ease-in-out infinite;
  color: transparent;
  cursor: progress;
`;

const Container = styled.div<{ height: number; width: number; circle?: boolean; color?: string }>`
  ${Loading}
  ${({ color }) => color && `background: var(${color});`}
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  ${({ circle }) => circle && `border-radius: 50%;`}
`;

const SkeletonLoading = ({ width, height, circle, color }: SkeletonLoadingProps) => (
  <Container width={width} height={height} circle={circle} color={color} />
);

export default SkeletonLoading;
